import { History } from "lucide-react";
import { useFetch } from "../lib/api";

export const NameHistory = ({ wid, version }) => {
  const { data } = useFetch(`/workers/${wid}/name-history?v=${version || 0}`);
  if (!data?.length) return null;
  return (
    <div className="c-surface p-6 c-rise" data-testid="name-history">
      <div className="c-eyebrow mb-2 flex items-center gap-2"><History size={13} />Name changes</div>
      <ul className="grid gap-2">
        {data.map((h) => (
          <li key={h.id} className="text-sm py-1.5 border-b border-[#1F2A3E]/60 last:border-0" data-testid="name-history-item">
            <span className="text-slate-400 line-through">{h.old_name}</span> <span className="text-slate-500">→</span> <span className="text-white">{h.new_name}</span>
            <div className="text-[11px] text-slate-500">{h.source} · {h.by} · {new Date(h.at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</div>
          </li>))}
      </ul>
    </div>);
};
